import React, { ChangeEvent, KeyboardEvent, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { IconEdit } from '../../assets/icons';
import { ErrorFormMessage } from '../error-form-message/error-form-message';
import { InputMui } from '../input-mui/input-mui';

type InputEditProps = {
  value: string;
  label: string;
  type?: string;
  id?: string;
  disabled?: boolean;
  setDisabled?: (value: boolean) => void;
  isBtnSave?: boolean;
  errorMessage?: string;
  step?: number;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onSave?: () => void;
};

export const InputEdit: React.FC<InputEditProps> = ({
  isBtnSave = true,
  type,
  disabled = false,
  value,
  label,
  id,
  errorMessage = '',
  setDisabled,
  onChange,
  onSave,
  step,
}) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const { t } = useTranslation('common');

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();

      if (onSave) onSave();
      else buttonRef.current?.click();
    }
  };

  const showEndIcon = !disabled && isBtnSave;

  return (
    <div className={c('input-edit max-width-desktop', { btn_save: isBtnSave })}>
      <InputMui
        value={value}
        label={label}
        disabled={disabled}
        id={id}
        type={type}
        step={step}
        onKeyDown={handleKeyDown}
        {...(onChange ? { onChange } : {})}
        {...(showEndIcon && {
          endIcon: !onSave ? (
            <button className="input-edit__btn input-edit__btn--submit" type="submit" ref={buttonRef}>
              {t('buttons.save')}
            </button>
          ) : (
            <button className="input-edit__btn input-edit__btn--submit" type="button" onClick={onSave} ref={buttonRef}>
              {t('buttons.save')}
            </button>
          ),
        })}
      />
      {(disabled || !isBtnSave) && (
        <button type="button" className="input-edit__btn" onClick={() => setDisabled && setDisabled(false)}>
          <IconEdit />
        </button>
      )}
      {errorMessage && <ErrorFormMessage errorMessage={errorMessage} />}
    </div>
  );
};
